import { render, staticRenderFns } from "./OtherPlansDesktop.vue?vue&type=template&id=2ba7d7d1"
import script from "./OtherPlansDesktop.vue?vue&type=script&lang=js"
export * from "./OtherPlansDesktop.vue?vue&type=script&lang=js"
import style0 from "./OtherPlansDesktop.vue?vue&type=style&index=0&id=2ba7d7d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports